import {connect} from 'react-redux';
import {createSelector} from 'reselect';
import {ProtocolView as Component} from './ProtocolView';
import {fetchProtocolScene} from '@learningblocks/protocol-constants/lib/Utilities';

import {
  setHeldObject,
  setTargetList,
  pushInteractions,
  setLastDrop,
  setSceneScale,
  setUserScale,
  setupProtocolScene,
  setTaskPages,
  setModal,
  showModal
} from '@learningblocks/protocol-redux/lib/Actions';

function mapStateToProps(state) {
  return {
    heldObject: state.notebook.protocolSection.scene.heldObject,
    targetList: state.notebook.protocolSection.scene.targetList,
    interactions: state.notebook.protocolSection.scene.interactions,
    solutions: (state.notebook.protocolSection.scene.hasOwnProperty('apparatus'))?state.notebook.protocolSection.scene.apparatus.solutions:null,

    undoAttempts: (state.notebook.protocolSection.scene.hasOwnProperty("undo"))?state.notebook.protocolSection.scene.undo.attempts:0,
    modalDisplay: (state.notebook.protocolSection.scene.hasOwnProperty("modal"))?state.notebook.protocolSection.scene.modal.display:false,

    drawerOpen: !state.notebook.notebookCollapsed,
    title: state.notebook.protocolSection.pageTitle,
    sceneType: state.notebook.protocolSection.currentSlide,
    apparatus: state.notebook.protocolSection.apparatus,
    sequence: state.notebook.protocolSection.sequence,
    description: getSlideDescription(state),
  };
}

function mapDispatchToProps(dispatch) {
  return {
    setModal: (data) => {
      dispatch(setModal(data))
    },
    showModal: (data) => {
      dispatch(showModal(data))
    },
    setHeldObject: (data) => {
      dispatch(setHeldObject(data))
    },
    setTargetList: (data) => {
      dispatch(setTargetList(data))
    },
    pushInteractions: (data) => {
      dispatch(pushInteractions(data))
    },
    setLastDrop: (data) => {
      dispatch(setLastDrop(data))
    },
    setSceneScale: (data) => {
      dispatch(setSceneScale(data))
    },
    setUserScale: (data) => {
      dispatch(setUserScale(data))
    },
    setupProtocolScene: (data) => {
      dispatch(setupProtocolScene(data))
    },
    setTaskPages: (data) => {
      dispatch(setTaskPages(data))
    }
  };
}

export const ProtocolView = connect(
  mapStateToProps,
  mapDispatchToProps
)(Component);

const getProtocolSection = ({notebook}) => notebook.protocolSection;
const getSlideDescription = createSelector(
  [getProtocolSection],
  (protocolSection) => {
    const currentSlide = fetchProtocolScene(
      protocolSection.allSlides,
      protocolSection.currentSlide
    );
    return currentSlide.description;
  }
);
